<template>
  <div
    id="confirm"
    class="flex min-h-[calc(100vh-4rem)] items-center justify-center py-16 sm:py-20"
  >
    <!-- 신청(결제) 완료 -->
    <section
      v-if="isSuccess"
      class="result"
      aria-labelledby="result-title"
    >
      <span class="result-icon result-icon--success" aria-hidden="true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2.4"
          stroke="currentColor"
          class="h-9 w-9"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m4.5 12.75 6 6 9-13.5"
          />
        </svg>
      </span>
      <h1 id="result-title" class="result-title">신청이 완료되었습니다</h1>
      <p class="result-desc">
        접수가 마감된 후에는 변경 및 취소가 어려우며,<br
          class="max-sm:hidden"
        />
        지도자용 예배/활동 매뉴얼은 컨퍼런스 현장에서 구입 가능합니다.
      </p>

      <!-- 가상계좌 결제일 경우 -->
      <div v-if="detail.pay_method == 'VBank'" class="vbank">
        <p class="vbank-guide">
          아래 가상계좌로 입금해 주시면 결제 완료 처리됩니다.
        </p>
        <dl class="vbank-info">
          <div class="vbank-row">
            <dt>입금 계좌</dt>
            <dd>
              {{ detail.paymentOthers.vact_bank_name }}
              <span class="mont">{{ detail.paymentOthers.vact_num }}</span>
            </dd>
          </div>
          <div class="vbank-row">
            <dt>예금주</dt>
            <dd>{{ detail.paymentOthers.vact_name }}</dd>
          </div>
          <div class="vbank-row">
            <dt>결제 금액</dt>
            <dd class="text-lg font-bold text-main-navy">
              <span class="mont">{{
                Number(detail.tot_price).toLocaleString()
              }}</span
              >원
            </dd>
          </div>
          <div class="vbank-row">
            <dt>입금 기한</dt>
            <dd>
              <span class="mont"
                >{{ formatDate(detail.paymentOthers.vact_date) }} 23:59:00</span
              >
              까지
            </dd>
          </div>
        </dl>
      </div>

      <div class="result-actions">
        <button
          type="button"
          class="result-button result-button--primary"
          @click="payDevice == 'pc' ? goMyConfList() : goMyConfListApp()"
        >
          신청 내역 보기
        </button>
        <!-- PC는 결제 팝업이라 부모 창을 홈으로 보내고 팝업을 닫는다 -->
        <button
          v-if="payDevice == 'pc'"
          type="button"
          class="result-button result-button--secondary"
          @click="goList"
        >
          홈으로
        </button>
        <a v-else href="/" class="result-button result-button--secondary">
          홈으로
        </a>
      </div>
    </section>

    <!-- 승인 실패 -->
    <section
      v-else-if="isFail"
      class="result"
      aria-labelledby="result-title"
    >
      <span class="result-icon result-icon--fail" aria-hidden="true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2.4"
          stroke="currentColor"
          class="h-9 w-9"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 7.5v5.25m0 3.75h.008v.008H12v-.008Z"
          />
        </svg>
      </span>
      <h1 id="result-title" class="result-title">결제에 실패하였습니다</h1>

      <div v-if="returnMsg" class="fail-reason">
        <p class="text-sm font-semibold text-gray-500">실패 사유</p>
        <p class="mt-1 text-[0.9375rem] text-gray-800 break-keep">
          {{ returnMsg }}
        </p>
      </div>

      <div class="result-actions">
        <!-- PC는 결제 팝업 - 닫으면 신청 화면으로 돌아가 다시 결제할 수 있다 -->
        <button
          v-if="payDevice == 'pc'"
          type="button"
          class="result-button result-button--primary"
          @click="closeWindow"
        >
          창 닫기
        </button>
        <a v-else href="/" class="result-button result-button--primary">
          홈으로
        </a>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";

export default {
  name: "EduRegisterConfirmPage",
  data() {
    return {
      oid: "",
      payDevice: "",
      atPhone: "",
      detail: {
        pay_method: "",
      },
      returnCode : "",
      returnMsg : ""
    }
  },
  computed: {
    // 승인 결과 - PC는 0000, 모바일은 00 이 성공
    isSuccess() {
      return (
        (this.payDevice == "pc" && this.returnCode == "0000") ||
        (this.payDevice == "mobile" && this.returnCode == "00")
      );
    },
    isFail() {
      return (
        (this.payDevice == "pc" || this.payDevice == "mobile") &&
        !this.isSuccess
      );
    },
  },
  methods: {
    closeWindow() {
      self.close()
    },
    goList() {
      opener.location.href = "/"
      self.close()
    },
    goMyConfListApp() {
      const browserInfo = this.detectWebView();
      if( browserInfo == 'android' || browserInfo == 'ios' ){
        // opener.location.href = "/profile/confList/app"
        router.push({path: '/profile/confList/app'});
      }
      else {
        router.push({path: '/profile/confList'});
        // opener.location.href = "/profile/confList"
      }
    },

    goMyConfList() {
      const browserInfo = this.detectWebView();
      if( browserInfo == 'android' || browserInfo == 'ios' ){
        // opener.location.href = "/profile/confList/app"
        router.push({path: '/profile/confList/app'});
      }
      else {
        opener.location.href = "/profile/confList"
      }
      self.close()
    },

    reload() {
      location.reload();
    },

    async sendOkMessage() {
      try {
        // 핸드폰번호 유효성 검사
        const phoneReg = /^[0-9]*$/;
        if( this.atPhone.length > 10 && phoneReg.test(this.atPhone) ){

          const url = '/v2/sender/send';
          const body = [{
            message_type: 'AT',
            phn: this.atPhone,
            profile: '4ece7da6a5cd10889ee20c4048afad3b554e419f',
            msg: '[총회교육개발원]\n' +
                  '총회교육개발원 여름성경학교 컨퍼런스에 등록이 완료되었습니다. 감사합니다.',
            tmplId: 'conference_join_01',
            smsKind: 'S',
            msgSms: '[총회교육원] 컨퍼런스에 등록이 완료되었습니다. 감사합니다.',
            smsSender: '025595648',
          }];
          const response = await axios.post(url, body, {
            headers: {
              "Content-Type":"application/json",
              "userId": "eduwind"
            }
          });
          console.log(response.data);

        }
      } catch (error) {
        console.error(error);
      }
    },

    async getPaymentResult() {
      try {
        const url = `/api/payment/result?oid=${this.oid}&device=${this.payDevice}`;
        const response = await axios.get(url);
        console.log(response.data);
        if( response.data.err_code === 0 ){
          this.atPhone = response.data.contents.buyer_tel;
          // this.atPhone = '01020083033';
          if( this.atPhone ){
            await this.sendOkMessage();
          }
        }
      } catch (error) {
        console.error(error);
      }
    },

    async payResult() {


      try {
        // const response = await axios.get(`/api/payment/result?oid=${this.oid}&device=${this.payDevice}`);
        // console.log(response);
        /*console.log(response.data);
        console.log(response.data.contents);
        // const contents = JSON.stringify(response.data);
        const contents = JSON.parse(response.data);
        console.log(contents.contents);

        this.detail = response.data.contents.detail;

        console.log(this.detail)*/
      } catch (error) {
        console.error(error);
      }
    },

    formatDate(date) {
      const year = date.slice(0, 4);
      const month = date.slice(4, 6);
      const day = date.slice(6, 8);
      return `${year}-${month}-${day}`;
    },

    detectWebView() {
      // 사용자 에이전트 문자열을 가져옴
      const mobileType = navigator.userAgent.toLowerCase();
      let detect = "PC";
      if (mobileType.indexOf('android') > -1) {
        detect = "android";
      }
      else if (mobileType.indexOf('iphone') > -1 || mobileType.indexOf('ipad') > -1 || mobileType.indexOf('ipod') > -1) {
        detect = "ios";
      }

      return detect;
    }
  },

  created() {
    this.oid = this.$route.query.oid;
    this.payDevice = this.$route.query.payDevice;
    this.returnCode = this.$route.query.resultCode;
    this.returnMsg = this.$route.query.resultMsg;

    if( this.oid && this.payDevice ){
        // this.getPaymentResult();
    }

    if(this.returnCode == "0000" || this.returnCode == "00"){ //승인성공 시
      this.payResult();

      if(this.payDevice == "pc"){
        window.opener.location.replace('/profile/confList');
      }
    }
  },

  mounted() {


  }
}

</script>

<style scoped>
  .mont {
    font-weight: 500;
    letter-spacing: 0.05em;
  }

  .result {
    @apply flex w-full flex-col items-center text-center;
  }

  .result-icon {
    @apply flex h-20 w-20 items-center justify-center rounded-full ring-8;
  }

  .result-icon--success {
    @apply bg-emerald-500 text-white ring-emerald-50;
  }

  .result-icon--fail {
    @apply bg-red-500 text-white ring-red-50;
  }

  .result-title {
    @apply mt-8 text-2xl sm:text-[1.75rem] font-bold tracking-tight text-gray-900;
  }

  .result-desc {
    @apply mt-3 text-[0.9375rem] sm:text-base leading-relaxed text-gray-500 break-keep;
  }

  /* 가상계좌 */
  .vbank {
    @apply mt-8 w-full max-w-md text-left;
  }

  .vbank-guide {
    @apply text-center text-sm font-semibold text-main-navy break-keep;
  }

  .vbank-info {
    @apply mt-3 divide-y divide-gray-200 rounded-2xl border border-gray-200 bg-slate-50 px-5;
  }

  .vbank-row {
    @apply flex items-baseline justify-between gap-4 py-3.5;
  }

  .vbank-row dt {
    @apply shrink-0 text-sm text-gray-500;
  }

  .vbank-row dd {
    @apply text-right text-[0.9375rem] font-medium text-gray-900 break-all;
  }

  .fail-reason {
    @apply mt-6 w-full max-w-md rounded-2xl bg-slate-50 px-5 py-4 text-left;
  }

  .result-actions {
    @apply mt-10 flex w-full max-w-md flex-col gap-2.5 sm:flex-row-reverse;
  }

  .result-button {
    @apply flex h-[3.25rem] w-full items-center justify-center rounded-xl sm:w-auto sm:grow sm:basis-0 text-[0.9375rem] font-semibold transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-main-navy/30;
  }

  .result-button--primary {
    @apply bg-main-navy text-white hover:bg-main-navy/90;
  }

  .result-button--secondary {
    @apply border border-gray-300 bg-white text-gray-700 hover:bg-gray-50;
  }
</style>